<div class="row top_heading review-panel">
    <span class="ml-2">Review Summary </span>  
</div> 
<div class="row review-panel">
 <div class="col-12 mb-2">    
    <div class="row top_heading mb-2" *ngIf="taskJson">
        Task Details
    </div>
    <div class="row" *ngIf="taskJson">
        <form [formGroup]="addForm"> 
        <div *ngFor="let _data of taskJson; let i = index;" class="elm-container pt-2">
            <!-- <div class="pl-2 component-label">{{_data.label}}</div> -->
            
            <app-component-loader
            [rendercomponent]="_data.layoutCode"  *ngIf="_data.controlType == 'STANDARD'"></app-component-loader>
            <app-component-loader class="inlineblock" *ngIf="_data.controlType == 'CUSTOM'"
            [rendercomponent]="_data.layoutCode"
            [sublabel]="_data.subText"
            [validation]="_data.mandatory"
            [readonly]="_data.readonly"
            [minLength]="_data.minLength"
            [maxLength]="_data.maxLength"
            [placeHolders]="_data.placeholder"
            [groupElementProperty]="_data.groupElementProperty"
            [typeOfButton]="_data.layoutCode ==='StepStatusUpdateComponentLibraryComponent' && _data.label === 'Edit' ? 'EDIT' : 'MARK_COMPLETE'"
            [group]="addForm"
            [groupName]="_data.layoutCode ==='VdSwitchGroupComponent'  ? 'switchGroup' : null"
            [inputParams]="_data"           
        ></app-component-loader> 
            <hr class="separator" *ngIf="i !== taskJson?.length-1">
        </div>
         </form>
    </div>

    <div class="row top_heading mb-2 mt-2" *ngIf="stepsJson">
        <div class="col-12">
            Step Details
        </div>        
    </div>
    <div class="row mb-2" *ngIf="stepsJson">
        <div class="col-12">
            <app-vd-builder-preview-steps [inputStepList]="stepsJson" *ngIf="stepsJson"></app-vd-builder-preview-steps>
        </div>
    </div>
    
</div>
</div>
<div class="row">
    <div class="col-12 mt-4">
        <p-divider type="dashed"></p-divider>
        <div class="buttonContainer my-2">
            <div> <button type="button" class="btn vdCancelBtn mr-3" (click)="hadleCancel()">CANCEL</button></div>
            <div *ngIf="!visaObj?.previousTaskTypeId && isEditVisa"> <button type="submit" [disabled]="publishedOn" class="btn vdCreateBtn mr-3" (click)="publish()">PUBLISH</button></div>
            <div *ngIf="visaObj?.previousTaskTypeId && isEditVisa"> <button type="submit"  class="btn vdCreateBtn mr-3" (click)="publish()">RE-PUBLISH</button></div>
        </div>
    </div>
</div>
